export default "__VITE_ASSET__0a15928e__"